export const ADMIN_BASE = '/admin/'

export const DJANGO_LOGIN_URL = ADMIN_BASE + 'login/?next=/'
export const DJANGO_LOGOUT_URL = ADMIN_BASE + 'logout/?next=/'

export const API_TIMEOUT = 100000

export const DJANGO_ADMIN_URLS = {
  employeeList: ADMIN_BASE + 'employees/employee/',
  clientList: ADMIN_BASE + 'clients/client/'
}

export const PRIORITY_MAPPER = {
  LOW: 10,
  MEDIUM: 20,
  HIGH: 30,
  CRITICAL: 40
}

export const VERSION_KEY = 'heedview-version'

export const COMMUNITY_LIVING_SERVICE_ABBREVIATION = 'KE'

export const SERVICE_COLOR_MAPPER = {
  TE: '#c1fc53',
  IET: '#53c6fc',
  TT: '#ff8a5f',
  KE: '#f5d742'
}
